import { JobOfferFragment } from '../gen/graphql/JobRoute.generated';

const CLOSING_DATETIME = new Date('2025-12-18T15:00:00.000Z');

export function isOfferAfterClosingDate(offer: JobOfferFragment) {
  return new Date(offer.workTimeStartAt) >= CLOSING_DATETIME;
}
